// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"662":"c005bd7c","968":"d6b0bc69"}[chunkId] + ".chunk.css";
};